import React, {
  useState,
  useEffect,
  useContext
} from 'react';
import { Redirect, useHistory } from "react-router-dom";
import { Context } from "../../../context/globalContext";
import { PaymentQueries } from '../../../helpers/GraphqlQueriesLib'

import { useQuery } from '@apollo/client';
import {
  SelectSubscriptionComponent,
  SurveyComponent,
  CheckoutComponent
} from '../components'
import { loadStripe } from '@stripe/stripe-js';
import firebase from 'firebase/app'
import 'firebase/auth'
import { RETRIEVE_STRIPE_CUSTOMER } from '../../../helpers/graphqlQueries';
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);

export default function PaymentScreen(){
  const history = useHistory();
  const {
    state: { user },
    dispatch: { logout }
  } = useContext(Context);

  const email = user?.email;
  const [isCheckout, setIsCheckout] = useState(false);
  const [isOfferRejected, setIsOfferRejected] = useState(false)
  const [selectedMembership, setSelectedMembership] = useState({});

  const { loading: membershipLoading, data } = useQuery(PaymentQueries.GET_MEMBERSHIP)
  const { data:stripeCustomer, refetch:refetchStripeCustomer} = useQuery(RETRIEVE_STRIPE_CUSTOMER,{variables:{customerId:user.stripe_customer_id}});
  const stripeSubscription = stripeCustomer?.retrieveStripeCustomer?.result?.subscriptions?.data[0];


  useEffect(() => {
    if (user.membership?.type === 'LifeTime') {
      history.replace('/')
    }
  }, [user]);

  const selectMembershipHandler = async (value) => {
    const { membership } = data
    const selectedMembership = membership.find((element) => {
      if (element.type === value) return element
    })

    setSelectedMembership(selectedMembership)
    setIsCheckout(true)
  }

  const backHandler = () => {
    setIsCheckout(false)
    setIsOfferRejected(false)
  }

  const rejectionHandler = () => {
    setIsOfferRejected(true)
  }

  if (isCheckout)
    return (
      <CheckoutComponent
        stripePromise={stripePromise}
        paypalClientID={process.env.REACT_APP_PAYPAL_CLIENT_ID}
        userEmail={email}
        selectedMembership={selectedMembership}
        cancelClick={backHandler}
        membershipLoading={membershipLoading} 
        stripeSubscription={stripeSubscription}
      />
    )
  else if (isOfferRejected)
    return (
      <SurveyComponent
        cancelClick={backHandler}
        user={user}
        logout={() => {
          firebase.auth().signOut();
          logout();
        }}
      />
    )

  return (membershipLoading ? (null) : (
    <SelectSubscriptionComponent
      membershipArray={data.membership}
      selectMembershipClick={selectMembershipHandler}
      user={user}
      rejectClick={rejectionHandler} 
      needRetryPayment={(stripeSubscription?.status==='incomplete'||stripeSubscription?.status==='past_due'||stripeSubscription?.status==='unpaid')}
    />
  ))

}

